import { API_endpoints } from "../config";

export const setEmployPassword = async (id: number, password: string, email: string) => {
    try {
        const response = await fetch(API_endpoints.setEmployPassword, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
            },
             credentials: 'include',
            body: JSON.stringify({ id, password, email }),
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || "Fehler beim Laden von Daten.");
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Fehler beim  buchung Anfrage:", error);
        throw error;
    }
};
